import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ContextServiceBase } from '@app/baseBtl/context/context.service';
import { Oauth2RessourceService } from '@app/oauth2/oauth2-resources.service';

import { ConfigurationService, Oauth2Service } from '@common';
import { Observable, from as observableFrom, of as observableOf } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CustomerContextService } from '../../../context/child/customer-context.service';
import { OrdersInterface } from '../../../sales/orders.interface';
import { IPromotionToTransformBase } from '../../checkout/cart/promotions/promotion.interface';
import { ContextInterfaceBase } from '../context.interface';

@Injectable({
    providedIn: 'root',
})
export class PromoContextServiceBase implements ContextInterfaceBase {
    public keySerialize: string = 'PromoContextService';
    public promotions: IPromotionToTransformBase[] = null;
    public convergence: IPromotionToTransformBase[] = null;
    public currentOrders: OrdersInterface;
    private hasUnicity: boolean = false;

    constructor(
        protected oauth2Ressource: Oauth2RessourceService,
        @Inject(DOCUMENT) protected document: Document,
        protected configService: ConfigurationService,
        protected oauth2Service: Oauth2Service,
        protected http: HttpClient,
    ) {}

    public create(): Observable<ContextInterfaceBase> {
        const instance: PromoContextServiceBase = new PromoContextServiceBase(
            this.oauth2Ressource,
            this.document,
            this.configService,
            this.oauth2Service,
            this.http,
        );
        return instance.config();
    }

    public updateContext(contextServiceBase: ContextServiceBase): Observable<ContextServiceBase> {
        if (this.hasUnicity) {
            // eslint-disable-next-line max-len
            contextServiceBase
                .get<CustomerContextService>(CustomerContextService)
                .getOrders()
                .pipe(tap((data) => (this.currentOrders = data)))
                .subscribe();
        }
        return observableFrom([contextServiceBase]);
    }

    public serialize(): { [index: string]: any } {
        return {};
    }

    public config(): Observable<ContextInterfaceBase> {
        this.hasUnicity = this.promotions?.some((promotion) => promotion.uses_per_customer > 0);

        return observableOf(this);
    }
}
